export default __webpack_public_path__ + "static/media/astrid.df81ef93.jpg";